
import apiEndpoints from '../lib/apiEndpoints';
import apiCall from './apiCall';
import { getBase64Data } from '../lib/helper';

export const getMerchantListApi = (data: {
  pageNo?: string | number;
  limit?: string | number;
  payload?: Record<string, string>;
  cancelKey?: string;
}): any => {
  const { pageNo, limit, payload, cancelKey } = data;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_GET_MERCHANT_LIST,
    query: {
      pageNo,
      limit,
      payload: getBase64Data(payload),
    },
    payload: {
      ...payload,
    },
    cancelKey,
  });
};

export const getMerchantMigrationDataApi = (data: {
  pageNo?: string | number;
  limit?: string | number;
  payload?: Record<string, string>;
  cancelKey?: string;
}): any => {
  const { pageNo, limit, payload, cancelKey } = data;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_GET_MERCHANT_MIGRATION_DATA,
    query: {
      pageNo,
      limit,
      payload: getBase64Data(payload),
    },
    payload: {
      ...payload,
    },
    cancelKey,
  });
};

export const migratedMerchantSearchApi = (data: {
  limit?: string | number;
  searchPattern?: string | number;
  cancelKey?: string;
}): any => {
  const { limit, searchPattern, cancelKey } = data;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_MIGRATED_MERCHANT_SEARCH,
    query: {
      limit,
      searchPattern,
    },
    cancelKey,
  });
};

export const merchantSearchApi = (data: {
  limit?: string | number;
  searchPattern?: string | number;
  cancelKey?: string;
}): any => {
  const { limit, searchPattern, cancelKey } = data;
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.UNIFIED_MERCHANT_SEARCH,
    query: {
      limit,
      searchPattern,
    },
    cancelKey,
  });
};

export const merchantOdsDataApi = () => {
  return apiCall({
    method: 'get',
    endpoint: apiEndpoints.GET_MERCHANT_ODS_DATA,
  });
};
